import { RocketIcon, UpdateIcon, } from '@radix-ui/react-icons';
import { useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { toast } from '../ui/use-toast';

const GenerateFamilyTreesDialog = ({ dropdown }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleChange = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/crons/generate-family-tree`);

            if (response.data.generatedTreesCount) {
                toast({
                    title: 'Släktträd genererade.',
                    description: `${response.data.generatedTreesCount} släktträd har genererats på nytt.`,
                });
            } else {
                toast({
                    title: 'Inga släktträd att generera.',
                });
            }
            setIsDialogOpen(false);
        } catch (error) {

            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            {dropdown ? (
                <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                    <DialogTrigger className='flex items-center w-full'>
                        <RocketIcon className='mr-3'/>
                        Generera släktträd
                    </DialogTrigger>
                </DropdownMenuItem>
            ) : (
                <DialogTrigger className='flex items-center w-full' asChild>
                    <Button>
                        <RocketIcon className='mr-3'/>
                        Generera släktträd
                    </Button>
                </DialogTrigger>
            )}
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>
                        Generera släktträd
                    </DialogTitle>
                    <DialogDescription>
                    Du håller på att generera släktträd i systemet, vilket är resurskrävande och kan påverka prestandan för alla användare. Är du säker på att du vill fortsätta? Observera att du kan generera högst 5000 släktträd per omgång. För fler än 5000 krävs flera separata genereringar.
                    </DialogDescription>
                </DialogHeader>
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button
                        onClick={handleChange}
                        disabled={isLoading}>
                        {(isLoading) ? <UpdateIcon className='loader-spinner' /> : <>Generera</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default GenerateFamilyTreesDialog;
